/* @flow */
import router from './router';
import store from './store';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式

NProgress.configure({
  showSpinner: false,
});

import { getToken } from './utils/auth';

NProgress.configure({ easing: 'ease', speed: 500 });

const whiteList = ['/login','/logined', '/404', '/401', '/500', '/refresh', '/test'];

/**
 * 进入路由之前
 */
router.beforeEach(async (to, from, next) => {
  // await store.dispatch('FedLogOut');

  const isNull = from.name == null;
  if (!isNull) {
    NProgress.start();
  }
  if (!getToken()) {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
      NProgress.done();
    } else {
      location.href = '/login';
    }
    return;
  }

  // 有token用户
  try {
    const routerInfo = await initInfo(store);
    // login后添加动态路由
    if (!routerInfo.ROUTERS_IS_MOUNTED) {
      router.addRoutes(store.getters.addRouters);
      next({
        ...to,
        replace: true
      });
    } else {
      // 已经添加了动态路由，但是访问的路由未在vue-router定义
      to.matched.length === 0 ? next('/404') : next();
      NProgress.done();
    }
  } catch (err) {
    // 如果token过期，则路由跳转获取用户信息时报错，被捕获，则退出
    console.log(err);
    await store.dispatch('FedLogOut');
    next('/404');
    NProgress.done();
  }
});

/**
 * 进入路由之后
 */
router.afterEach((to, from) => {
  // store.commit('SET_TITLE', to.meta.title);
  // store.commit('SET_IS_BACK', to.meta.isBack);
  NProgress.done(); // 结束Progress
});

/**
 * 初始化用户信息和路由信息
 */
async function initInfo(store) {
  try {
    await store.dispatch('getUserInfo');
    const addRouters = store.getters.addRouters;
    // const role = store.getters.role;
    const permission = store.getters.permission;
    // 路由已添加时返回路由已经添加
    if (addRouters && addRouters.length > 0) {
      return Promise.resolve({
        ROUTERS_IS_MOUNTED: true
      });
    }

    // 根据角色，生成对应的路由表
    const newAddRouters = await store.dispatch('GenerateRoutes', { permission });
    return Promise.resolve({
      ROUTERS_IS_MOUNTED: false,
      addRouters: newAddRouters
    });
  } catch (err) {
    return Promise.reject(err);
  }

}